import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faLinkedin,
  faBehance,
} from "@fortawesome/free-brands-svg-icons";

export default function Headerpart1() {
  return (
    <div>
      <div
        className="container-fluid header1"
        style={{
          maxWidth: "1440px",
          height: "auto",
        }}
      >
        <div
          className="row header2"
          style={{
            maxWidth: "1280px",
            height: "auto",
            justifyContent: "space-between",
            flexWrap: "wrap",
            alignItems: "flex-start", 
          }}
        >
          <div
            className="col-lg-8 col-md-12 col-sm-12 header3"
            style={{
              maxWidth: "700px",
              height: "auto",
              gap:'10px',
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start", 
            }}
          >
      <h1 className="headingfirst dogicapixel">
  Hello I'am{" "}
  <span
    className="heading2 little-malio-font"
    style={{ position: "relative", top: "5px" }}
  >
    Obaid
  </span>
</h1>

            <h1 className="headingsecond pixel-mono">
              Digital{" "}
              <span
                className="ss Pixel-Operator"
                style={{
                  WebkitTextStroke: "2px black",
                  color: "white",
                  backgroundColor: "transparent",
                }}
              >
                ARCHITECT
              </span>
            </h1>
            <p className="parafirst Pixel-Operator" style={{ color: "#71717A" }}>
              A VISIONARY ART DIRECTOR/CREATIVE SPECIALIST WITH A PROVEN TRACK
              RECORD OF SUCCESS IN VISUAL COMMUNICATIONS/ADVERTISING, FASHION,&
              FILM. WITH A KEEN EYE FOR AESTHETICS AND A DEEP UNDERSTANDING OF
              HUMAN BEHAVIOR, DIABO EXCELS AT CRAFTING COMPELLING NARRATIVES AND
              INNOVATIVE CONCEPTS THAT CAPTIVATE AUDIENCES AND DRIVE IMPACTFUL
              RESULTS.
            </p>
            <div className="icons"  style={{ display: "flex", gap: "40px" }}>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  size="2x"
                  style={{
                    border: "2px solid black",
                    padding: "10px 13px",
                    color: "black",
                    borderRadius: "5px",
                  }}
                />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  size="2x"
                  style={{
                    border: "2px solid black",
                    padding: "10px 15px",
                    color: "black",
                    borderRadius: "5px",
                  }}
                />
              </a>
              <a
                href="https://www.behance.net"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faBehance}
                  size="2x"
                  style={{
                    border: "2px solid black",
                    padding: "10px",
                    color: "black",
                    borderRadius: "5px",
                  }}
                />
              </a>
            </div>
          </div>

          <div
            className="col-lg-3 col-md-12 col-sm-12 img2 mb-5"
            style={{
              textAlign: "center",
              marginTop: "0",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start", 
            }}
          >
            <img
              src="/images/Hacker.png"
              alt="Hacker"
              style={{
                width: "300px",
                height: "300px",
                maxWidth: "300px",
                margin: "0 auto",
                // alignSelf: "flex-start", 
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
